import { h, Component } from "preact";
import UIkit from "uikit";
import logo from "../img/logo.svg";
import { Text } from "preact-i18n";

import Language from "./Language";
class NavBar extends Component {
  constructor(props) {
    super(props);
  }
  scrollMe = (e, data) => {
    e.preventDefault();
    let t = document.getElementById(data);
    window.scrollTo(0, t.offsetTop);
  };
  render() {
    return (
      <div uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; bottom: #transparent-sticky-navbar ">
        <nav
          class="uk-navbar-container"
          uk-navbar
          style="position: relative; z-index: 980;"
        >
          <div class="uk-navbar-left">
            <a class="uk-navbar-item uk-logo" href="#">
              <img src={logo} width="125" uk-svg />
            </a>
          </div>


          <div class="uk-navbar-right">
            <ul class="uk-navbar-nav responsive-nav">
              <li class="uk-active">
                <a
                  href="#home"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "home")}
                >
                  <Text id="NavBar.home">Ínicio</Text>
                </a>
              </li>
              <li>
                <a
                  href="#aboutus"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "aboutus")}
                >
                  <Text id="NavBar.aboutUs">Sobre</Text>
                </a>
              </li>

              <li>
                <a
                  href="#services"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "services")}
                >
                  <Text id="NavBar.services">Características</Text>
                </a>
              </li>


              <li>
                <a
                  href="#howto"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "howto")}
                >
                  <Text id="NavBar.video">Conteúdos</Text>
                </a>
              </li>

              <li>
                <a
                  href="#contactus"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "contactus")}
                >
                  <Text id="NavBar.contact">Contacto</Text>
                </a>
              </li>
            </ul>
            <Language callback={this.props.langChanged} />
          </div>

        </nav>
        <div id="offcanvas-nav-primary" uk-offcanvas="overlay: true">
          <div class="uk-offcanvas-bar uk-flex uk-flex-column">
            <ul class="uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical">
              <li class="uk-active">
                <a
                  href="#home"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "home")}
                >
                  <Text id="NavBar.home">Ínicio</Text>
                </a>
              </li>


              <li>
                <a
                  href="#aboutus"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "aboutus")}
                >
                  <Text id="NavBar.aboutUs">Sobre</Text>
                </a>
              </li>

              <li>
                <a
                  href="#services"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "services")}
                >
                  <Text id="NavBar.services">Características</Text>
                </a>

                <div class="uk-navbar-dropdown">
                  <ul class="uk-nav uk-navbar-dropdown-nav">
                    <li>
                      <a href="#">
                        <Text id="NavBar.technology">Technology</Text>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <Text id="NavBar.ac">Agricultural Consulting</Text>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>


              <li>
                <a
                  href="#team"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "team")}
                >
                  <Text id="NavBar.team">Como Funciona</Text>
                </a>
              </li>
              <li>
                <a
                  href="#contactus"
                  uk-scroll
                  onClick={e => this.scrollMe(e, "contactus")}
                >
                  <Text id="NavBar.contact">Contact Us</Text>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default NavBar;
